import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/button';
import CustomInput from '../../components/customInput/CustomInput';
import { validateTokenAndPassword, changePassword } from '../../redux/passwordResetSlice';
import { validatePassword } from '../../utils/commonUtil';

const ResetPasswordPage = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [errors, setErrors] = useState({
    newPassword: '',
    confirmNewPassword: '',
  });
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { status, loading, error } = useSelector((state) => state.passwordReset);

  useEffect(() => {
    // Get email and token from URL query parameters
    const email = searchParams.get('email');
    const token = searchParams.get('token');

    console.log('email:' + email, 'token:' + token);

    if (email && token) {
      dispatch(validateTokenAndPassword({ email, token }));
    }
  }, [dispatch, searchParams]);

  const handleBackToLogin = () => {
    navigate('/login');
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      newPassword: '',
      confirmNewPassword: '',
    };

    if (!validatePassword(newPassword)) {
      newErrors.newPassword = 'Your password must be at least 8 characters, and should contain the following: upper case letters, lower case letters and numbers.';
      isValid = false;
    }

    if (newPassword !== confirmNewPassword) {
      newErrors.confirmNewPassword = 'Your new passwords do not match.';
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = searchParams.get('email');
    const token = searchParams.get('token');

    if (!validateForm()) return;

    if (email && token && newPassword && confirmNewPassword) {
      dispatch(changePassword({
        confirmPassword: confirmNewPassword,
        email,
        newPassword,
        token
      }));
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh'
    }}>
      <div style={{
        padding: '30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
        height: '60%',
        border: '1px solid #ddd',
        boxShadow: '0 2px 4px #f4f4f4',
        borderRadius: '5px'
      }}>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <p style={{ fontSize: '18px', textAlign: 'center', margin: 0, fontWeight: '600', marginBottom: '30px' }}>Change Password</p>
          {(status === '200' || status === '400') && (
            <>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <CustomInput
                  type="password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    setNewPassword(inputValue);
                    if (inputValue === '') {
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        newPassword: ''
                      }));
                    } else if (!validatePassword(inputValue)) {
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        newPassword: 'Your password must be at least 8 characters, and should contain the following: upper case letters, lower case letters and numbers.'
                      }));
                    } else {
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        newPassword: ''
                      }));
                    }
                  }}
                />
                {errors.newPassword && (
                  <p style={{ color: 'red', fontSize: '12px', marginTop: '4px', textAlign: 'left' }}>
                    {errors.newPassword}
                  </p>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '20px' }}>
                <CustomInput
                  type="password"
                  placeholder="Confirm New Password"
                  value={confirmNewPassword}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    setConfirmNewPassword(inputValue);
                    if (inputValue === '') {
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        confirmNewPassword: ''
                      }));
                    } else if (newPassword !== inputValue) {
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        confirmNewPassword: 'Your new passwords do not match.'
                      }));
                    } else {
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        confirmNewPassword: ''
                      }));
                    }
                  }}
                />
                {errors.confirmNewPassword && (
                  <p style={{ color: 'red', fontSize: '12px', marginTop: '4px', textAlign: 'left' }}>
                    {errors.confirmNewPassword}
                  </p>
                )}
              </div>
              {status === '400' && (
                <div className="alert alert-danger" style={{ marginTop: '30px' }}>
                  {error}
                </div>
              )}
              <Button
                type="submit"
                style={{
                  backgroundColor: 'rgb(237, 26, 61)',
                  color: 'white',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  border: 'none',
                  marginTop: '20px'
                }}
              >
                SUBMIT
              </Button>
            </>
          )}
          {status === '500' && (
            <div>
              <div className="alert alert-danger" style={{ marginTop: '30px' }}>
                {error && <p>{error}</p>}
              </div>
              <a href="" style={{
                marginTop: '20px', textDecoration: 'none', fontSize: '16px', fontWeight: '400', display: 'flex',
                justifyContent: 'center'
              }} onClick={handleBackToLogin}>
                Back to Login
              </a>
            </div>
          )}

          {status === 'passwordChanged' && (
            <>
              <div className="alert alert-success" style={{ marginTop: '30px' }}>
                Your Password has been changed.
              </div>
              <a href="" style={{ marginTop: '20px', textDecoration: 'none', fontSize: '16px', fontWeight: '400' }} onClick={handleBackToLogin}>
                Back to Login
              </a>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;    